module.exports = __webpack_public_path__ + "img/img14.ba533470.png";